import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c('nav',{staticClass:"white"},[_c('nav-desktop',{staticClass:"hidden-sm-and-down"}),_c('nav-mobile',{staticClass:"hidden-md-and-up"})],1),_c('the-marquee'),_c(VMain,{staticClass:"white"},[_c('router-view')],1),_c('cookie'),_c('deadstock-popup'),_c('on-hold-popup'),_c('footer-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }